import { render, staticRenderFns } from "./PaymentsAndUnallocatedDocuments.vue?vue&type=template&id=4060b725&"
import script from "./PaymentsAndUnallocatedDocuments.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndUnallocatedDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports